import axios from "axios";
import { t } from "i18next";
import _ from "lodash";

import AlertsService from "services/alerts-service";

import { putStorage } from "hooks/useStorage";

const ArticlesAPI = {
    getAllArticles: async () => {
        try {
            const { data: response } = await axios.get("/articles");
            putStorage("news", _.keyBy(response, "id"));
            return response;
        } catch (error) {
            throw AlertsService.showError(t("05z6bwi6f36t"));
        }
    },

    createArticle: async (data: any) => {
        try {
            const { data: response } = await axios.post("/articles", { ...data });
            await ArticlesAPI.getAllArticles();
            return response;
        } catch (error) {
            throw AlertsService.showError(t("1mgprx533xmj"));
        }
    },

    updateArticle: async (data: { id: string; [key: string]: any }) => {
        try {
            const { data: response } = await axios.put("/articles", { ...data });
            await ArticlesAPI.getAllArticles();
            AlertsService.showSuccess(t("m7exug625bs"));
            return response;
        } catch (error) {
            throw AlertsService.showError(t("22iyuvbmt3g"));
        }
    },

    deleteArticle: async (id: string) => {
        try {
            const { data: response } = await axios.delete(`/articles/${id}`);
            await ArticlesAPI.getAllArticles();
            AlertsService.showSuccess(t("51an55a76a4"));
            return response;
        } catch (error) {
            throw AlertsService.showError(t("k3d6hqehqn"));
        }
    },
};

export default ArticlesAPI;
